import React from 'react';
import { Text } from '@/components/typography';
import { useTranslations } from 'next-intl';

const Copyright = () => {
  const t = useTranslations('Footer');
  return (
    <Text as="p" size="xs">
      Copyright © {new Date().getFullYear()}. Kangaroo Tours Operadora Turística. {t('Todos os Direitos Reservados')}.
    </Text>
  );
};

export default Copyright;
